import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GiftCardTheme } from '@src/app/core/models/campaigns.model';
import { GiftCardsAppConstants } from '@src/app/shared/constants/ib-gift-cards-constants';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CampaignsService {

    constructor (
        @Inject('localStorageService') private localStorageService: angular.local.storage.ILocalStorageService,
        private translateService: TranslateService
    ) { }

    checkSpecialCampaignConfiguration (theme: string) {
        const specialCampaign = this.localStorageService.get('specialCampaign');
        const cardSelectedModels = GiftCardsAppConstants.CARD_SELECTED_MODELS;
        const isCorrectSpecialCampaign = Object.keys(cardSelectedModels).some(key => key === specialCampaign);

        return specialCampaign && isCorrectSpecialCampaign ? specialCampaign : theme;
    }

    async buildCardViewModel (theme) {
        const specialCampaign = this.checkSpecialCampaignConfiguration(theme);
        const conditionalTheme = 'FATHER';
        theme = (specialCampaign && theme === conditionalTheme) ? specialCampaign : theme;
        const dataModel: GiftCardTheme = GiftCardsAppConstants.CARD_SELECTED_MODELS[theme];

        const [
            altLogo,
            altFigure,
            altTheme,
            title,
            expiration,
            code
        ] = await Promise.all([
            this.getTranslate(dataModel.translates.altLogo),
            this.getTranslate(dataModel.translates.altFigure),
            this.getTranslate(dataModel.translates.altTheme),
            this.getTranslate(dataModel.translates.title),
            this.getTranslate(dataModel.translates.expiration),
            this.getTranslate(dataModel.translates.code)
        ]);

        return {
            ...dataModel,
            
            translates: {
                altLogo: altLogo,
                altFigure: altFigure,
                altTheme: altTheme,
                title: title,
                expiration: expiration,
                code: code
            }
        };
    }
    getTranslate = async (translateKey): Promise<string> => {
        return await lastValueFrom(this.translateService.get(translateKey));
    };
}
